export const FETCH_ECOLAB_ITEMDETAILS_LIST_REQUEST =
  "FETCH_ECOLAB_ITEMDETAILS_LIST_REQUEST";
export const FETCH_ECOLAB_ITEMDETAILS_LIST_SUCCESS =
  "FETCH_ECOLAB_ITEMDETAILS_LIST_SUCCESS";
export const FETCH_ECOLAB_ITEMDETAILS_LIST_FAILURE =
  "FETCH_ECOLAB_ITEMDETAILS_LIST_FAILURE";

export const ADD_UPDATE_ECOLAB_ITEMDETAILS_REQUEST = "ADD_UPDATE_ECOLAB_ITEMDETAILS_REQUEST";
export const ADD_UPDATE_ECOLAB_ITEMDETAILS_SUCCESS = "ADD_UPDATE_ECOLAB_ITEMDETAILS_SUCCESS";
export const ADD_UPDATE_ECOLAB_ITEMDETAILS_FAILURE = "ADD_UPDATE_ECOLAB_ITEMDETAILS_FAILURE";
